/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'note-files-create',
  components: {},
  props: ['noteId'],
  data() {
    return {
      file: '',
      name: '',
      description: '',
      submitted: false,
      uploadFileName: '',
      uploadingLoader: false,
    }
  },
  computed: {
  },
  mounted() {
    console.log(this.$route.params.id, "Test")
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.files = this.$refs.file.files[0];
      this.filesSize = this.$refs.file.files[0].size;
      if (this.$refs.file.files[0].size > 30000000) {
        alert('file size is exceed');
        this.name = ''
        this.uploadFileName = ''
      } else {
        this.name = this.files.name;
        this.uploadFileName = this.files.name
        console.log(this.name, this.filesSize);
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('user_notes', this.noteId);
          formData.append('name', this.name);
          formData.append('description', this.description);
          if (this.files)
            formData.append('file', this.files);
          $('.courseloader').show();
          this.$store.dispatch('createdUserNoteFiles', formData).then(response => {
            if (response.status === 200) {
              this.name = '';
              this.description = '';
              this.files = '';
              this.file = '';
              toast.success(response.data.msg);
              this.$validator.reset();
              $('.courseloader').hide();
              bus.$emit('HideAddNoteFilePopup', {
                status: false,
                reload: true
              })
            }
          }).catch(err => {
            console.error(err);
            $('.courseloader').hide();
            this.popupCloseFun()
          })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddNoteFilePopup', {
        status: false,
        reload: false
      })
    },
    resetFileBefore() {
      this.uploadFileName = '';
      this.$validator.reset();
    }
  }
}